<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">گراف درسی</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>
    <div class="p-3">
      <div v-if="loading" class="text-center mt-5">
        <p>در حال دریافت معلومات...</p>
      </div>
      <div v-else-if="lessons.length === 0" class="text-center mt-5 text_color_gray">
        مضمونی برای نمایش گراف یافت نشد.
      </div>
      <div v-else class="bg_white rounded-4 p-3 shadow-sm">
        <p class="text-center text_color_theme bold mb-3 p-2">صنف اول</p>
        <div 
          v-for="(lesson, index) in lessons" 
          :key="lesson.lesson_id" 
          :class="['d-flex align-items-center justify-content-between p-3 cursor-pointer', { 'border-top-light': index > 0 }]"
          @click="goToChart(lesson)"
        >
          <span>{{ lesson.title }}</span>
          <div class="arrow-circle">
             &lt;
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'ChartLessonsListView',
  data() {
    return {
      lessons: [],
      loading: false
    }
  },
  mounted() {
    this.fetchLessons();
  },
  methods: {
    async fetchLessons() {
      this.loading = true;
      try {
        const userId = localStorage.getItem('user_id');
        const formData = createFormData({ user_id: userId });
        const response = await apiClient.post('/chart_lessons', formData);
        
        if (response.data.status === 'ok' && response.data.data) {
          this.lessons = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching chart lessons:", error);
      } finally {
        this.loading = false;
      }
    },
    goToChart(lesson) {
      this.$router.push({ 
        name: 'LessonChart', 
        params: { lessonId: lesson.lesson_id },
        query: { lessonTitle: lesson.title } 
      });
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.border-top-light {
  border-top: 1px solid #f0f0f0;
}
.arrow-circle {
  background-color: #eef2ff;
  color: #4A00E0;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}
</style>